import { MutationCache } from '@tanstack/react-query'
import { parseApiError } from '@/lib/api'
import { successMessage, toast } from '@/lib/toast'

/**
 * Every write answers in the corner (`lib/toast.ts`): green with what happened
 * when its hook declares `meta.toast`, red with the server's sentence when it
 * failed — on top of whatever the form itself shows. One place, so a hook
 * added next month answers too.
 */
export function mutationNotices(): MutationCache {
  return new MutationCache({
    onSuccess: (data, _vars, _ctx, mutation) => {
      const message = successMessage(mutation.meta?.toast, data)
      if (message) toast.success(message)
    },
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.meta?.silentError) return
      toast.error(parseApiError(error).message)
    },
  })
}
